module.exports = __webpack_public_path__ + "static/media/HR.fed72d9b.svg";